"use client";

import React from "react";
import { Inbox, Mail } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface SupportInboxNotEnrolledProps {
  companyName?: string | null;
  onEnroll: () => void;
}

/** Empty state for a company with no Google support group yet, plus the CTA. */
export function SupportInboxNotEnrolled({
  companyName,
  onEnroll,
}: SupportInboxNotEnrolledProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Inbox className="w-5 h-5 text-gray-600 dark:text-gray-400 shrink-0" />
        <h3 className="text-base md:text-lg font-semibold text-card-foreground">
          Support Inbox
        </h3>
      </div>
      <Card>
        <CardContent className="pt-6 space-y-4">
          <p className="text-sm text-muted-foreground">
            <span className="font-medium text-card-foreground">
              {companyName || "This company"}
            </span>{" "}
            isn&apos;t enrolled in a Google support group yet. Enroll one so
            inbound support email flows into the Hub as tickets and
            communications — and shows up here in real time.
          </p>
          <Button type="button" onClick={onEnroll}>
            <Mail className="w-4 h-4 mr-2" />
            Enroll support group
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
